import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import {Field, Validator} from '../../jspb/flow_pb';
import TypeCase = Field.TypeCase;
import {FormArray} from '@angular/forms';
import {FieldValue} from '../../jspb/flow_api_pb';
import {FlowField} from './flow-field';
import {PairModel} from '../../pair-wrapper/pair-model';
import {BehaviorSubject, Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';

@Component({
  selector: 'flow-field',
  templateUrl: './flow-field.component.html',
  styleUrls: ['./flow-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowFieldComponent implements AfterViewInit, OnInit {
  TypeCase = TypeCase;
  @Input() field: Field;
  @Input() showCurrentFieldIndicator: boolean;
  @Output() focusNextField: EventEmitter<void> = new EventEmitter();

  @ViewChild(FlowField) flowField: FlowField;

  fields: FormArray;
  showAddAnotherButton$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  validators$: Observable<Validator[]>;

  constructor(public pairModel: PairModel) {}

  ngOnInit() {
    this.initializeAddAnotherButton();
    this.validators$ = this.pairModel.fieldIdToValidators$.pipe(
      first(),
      map(
        (fieldIdToValidators) =>
          fieldIdToValidators.get(this.field.getFieldId()) || []
      )
    );
  }

  ngAfterViewInit() {
    this.fields = this.flowField.fields;
  }

  getFieldValue(): FieldValue | null {
    return this.flowField.getFieldValue();
  }

  reset() {
    this.flowField.reset();
    this.initializeAddAnotherButton();
  }

  focusFirstInput() {
    this.flowField.focusFirstInput();
  }

  addAnother() {
    // We add one since we haven't added another field *yet*.
    if (
      this.field.hasMaximumMultiplicity() &&
      this.field.getMaximumMultiplicity().getValue() === this.fields.length + 1
    ) {
      this.showAddAnotherButton$.next(false);
    }
    this.flowField.addAnother();
  }

  private initializeAddAnotherButton() {
    // Don't show the "add another" button for auto-generated fields: they aren't
    // visible to the user.
    if (this.field.getTypeCase() === TypeCase.AUTO_GENERATED_UUID) {
      this.showAddAnotherButton$.next(false);
      return;
    }
    this.showAddAnotherButton$.next(
      !this.field.hasMaximumMultiplicity() ||
        this.field.getMaximumMultiplicity().getValue() >
          this.field.getMinimumMultiplicity()
    );
  }
}
